import type {BioIconProps} from '../../icons/common-types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

export default function TopOutdoorProductReviewsLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-1 text-2xl font-semibold text-white tablet:gap-0 tablet:text-[12px]">
      <svg {...attributes} width="24" height="33" viewBox="0 0 24 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1102_3142)">
          <path
            d="M22.1519 15.6778C25.8819 20.6278 19.9519 31.3878 19.9519 31.3878C19.9519 31.3878 7.97192 34.1378 4.24192 29.1878C0.511924 24.2378 0.561924 5.69775 0.561924 5.69775C0.561924 5.69775 18.4119 10.7378 22.1419 15.6778H22.1519Z"
            fill="#7BBC15"
          />
          <path d="M0.421997 5.62769L20.062 31.1477" stroke="white" strokeMiterlimit="10" />
          <path d="M8.21191 15.8377L9.61191 11.3477" stroke="white" strokeMiterlimit="10" />
          <path d="M4.11194 19.6577L10.6419 19.0977" stroke="white" strokeMiterlimit="10" />
          <path d="M13.022 22.4978L14.112 19.4778" stroke="white" strokeMiterlimit="10" />
          <path
            d="M11.562 0.467755L13.082 2.63776L15.612 1.86776C16.382 1.63776 17.002 2.51776 16.512 3.15776L14.922 5.26776L16.442 7.43776C16.902 8.09775 16.252 8.95776 15.492 8.69775L12.992 7.83776L11.402 9.94775C10.922 10.5878 9.90198 10.2378 9.91198 9.43775L9.96198 6.78776L7.46198 5.92776C6.70198 5.66776 6.72198 4.58775 7.49198 4.34775L10.022 3.57776L10.072 0.927755C10.082 0.127755 11.122 -0.192245 11.582 0.467755H11.562Z"
            fill="#FFD91F"
          />
          <path
            d="M20.672 10.2778L20.932 12.1478L22.792 12.4778C23.262 12.5578 23.352 13.1978 22.922 13.4078L21.222 14.2278L21.482 16.0978C21.542 16.5678 20.972 16.8478 20.642 16.5078L19.332 15.1478L17.632 15.9678C17.202 16.1778 16.762 15.7078 16.982 15.2978L17.872 13.6378L16.562 12.2778C16.232 11.9378 16.532 11.3678 17.002 11.4578L18.862 11.7878L19.752 10.1278C19.972 9.70778 20.612 9.81778 20.672 10.2978V10.2778Z"
            fill="#FFD91F"
          />
        </g>
        <defs>
          <clipPath id="clip0_1102_3142">
            <rect width="23.36" height="32.05" fill="white" transform="translate(0.0219727 0.107666)" />
          </clipPath>
        </defs>
      </svg>

      <span>Top Outdoor Product Reviews</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
